import { Modal } from 'ui';
import { DonorsSection } from './donors-section';

type P = {
  givingId: string;
  isOpened: boolean;
  onClose: () => void;
  title: string;
};

const DonationsModal = ({ givingId, isOpened, onClose, title }: P) => (
  <Modal
    className="donations-modal"
    isOpened={isOpened}
    onCancel={() => {
      onClose();
    }}
    title={title}
    width="medium"
  >
    <Modal.ScrollableContent>
      <DonorsSection givingId={givingId} title="top" type="top" />
      <DonorsSection givingId={givingId} title="recent" type="recent" />
    </Modal.ScrollableContent>
  </Modal>
);

export default DonationsModal;
